"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwDataGrid = _interopRequireDefault(require("../CwDataGrid.scss"));

var CellCustom = function CellCustom(props) {
  var cellContent = '--';

  if (typeof props.col.render === 'function') {
    cellContent = _react.default.createElement(props.col.render, props);
  }

  var className = (0, _classnames.default)(_CwDataGrid.default.cell, (0, _defineProperty2.default)({}, _CwDataGrid.default.cellCustomFlags, props.col.flags));
  return _react.default.createElement("div", {
    "data-cw-grid-cell-custom": true,
    className: className,
    style: {
      width: props.col.width
    }
  }, cellContent);
};

CellCustom.propTypes = {
  col: _propTypes.default.object.isRequired,
  // eslint-disable-next-line
  row: _propTypes.default.object.isRequired
};
var _default = CellCustom;
exports.default = _default;